/* eslint-disable */
import React from 'react'
import {Alert, Button, Form, Spinner} from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useDispatch, useSelector} from 'react-redux'
import {
  edmUpdateSettings,
  selectEdmSettingsSaveLoading,
} from '../../../redux/slices/edmsettings.slice'

const validationSchema = Yup.object({
  webServiceUrl: Yup.string().required('WebService URL zorunludur.').url('Geçerli bir URL giriniz.'),
  username: Yup.string().required('Kullanıcı adı zorunludur.'),
  txnId: Yup.string().required('TxnId zorunludur.'),
  channelName: Yup.string().required('Kanal adı zorunludur.'),
  applicationName: Yup.string().required('Uygulama adı zorunludur.'),
  password: Yup.string().min(4, 'Şifre en az 4 karakter olmalıdır.').optional(),
})

function EdmSettingsForm({settings}) {
  const dispatch = useDispatch()
  const saveLoading = useSelector(selectEdmSettingsSaveLoading)
  const [saveSuccess, setSaveSuccess] = React.useState(false)
  const [saveError, setSaveError] = React.useState(null)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      webServiceUrl: settings?.webServiceUrl || '',
      username: settings?.username || '',
      txnId: settings?.txnId || '',
      channelName: settings?.channelName || '',
      applicationName: settings?.applicationName || '',
      password: '',
      isEnabled: settings?.isEnabled ?? false,
    },
    validationSchema,
    onSubmit: async (values) => {
      setSaveSuccess(false)
      setSaveError(null)
      const body = {
        webServiceUrl: values.webServiceUrl,
        username: values.username,
        txnId: values.txnId,
        channelName: values.channelName,
        applicationName: values.applicationName,
        isEnabled: values.isEnabled,
        ...(values.password ? {password: values.password} : {}),
      }
      try {
        await dispatch(edmUpdateSettings(body)).unwrap()
        setSaveSuccess(true)
        formik.setFieldValue('password', '')
      } catch (err) {
        setSaveError(err?.message || 'Ayarlar kaydedilemedi.')
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      {saveSuccess && (
        <Alert variant='success' onClose={() => setSaveSuccess(false)} dismissible>
          Ayarlar başarıyla kaydedildi.
        </Alert>
      )}
      {saveError && (
        <Alert variant='danger' onClose={() => setSaveError(null)} dismissible>
          {saveError}
        </Alert>
      )}

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>WebService URL</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('webServiceUrl')}
          isInvalid={formik.touched.webServiceUrl && !!formik.errors.webServiceUrl}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.webServiceUrl}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>Kullanıcı Adı</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('username')}
          isInvalid={formik.touched.username && !!formik.errors.username}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.username}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>TxnId</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('txnId')}
          isInvalid={formik.touched.txnId && !!formik.errors.txnId}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.txnId}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>Kanal Adı</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('channelName')}
          isInvalid={formik.touched.channelName && !!formik.errors.channelName}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.channelName}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>Uygulama Adı</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('applicationName')}
          isInvalid={formik.touched.applicationName && !!formik.errors.applicationName}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.applicationName}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold'>
          Şifre{' '}
          <span className={`ms-2 small fw-normal ${settings?.passwordIsSet ? 'text-success' : 'text-warning'}`}>
            {settings?.passwordIsSet ? '✓ Şifre kayıtlı' : '⚠ Şifre girilmemiş'}
          </span>
        </Form.Label>
        <Form.Control
          type='password'
          placeholder='Değiştirmek istemiyorsanız boş bırakın'
          {...formik.getFieldProps('password')}
          isInvalid={formik.touched.password && !!formik.errors.password}
          disabled={saveLoading}
          autoComplete='new-password'
        />
        <Form.Text className='text-muted'>
          Boş bırakılırsa mevcut şifre korunur.
        </Form.Text>
        <Form.Control.Feedback type='invalid'>{formik.errors.password}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-8'>
        <Form.Check
          type='switch'
          id='isEnabled'
          label='Modülü Aktif Et'
          checked={formik.values.isEnabled}
          onChange={(e) => formik.setFieldValue('isEnabled', e.target.checked)}
          disabled={saveLoading}
        />
      </Form.Group>

      <Button type='submit' variant='primary' disabled={saveLoading}>
        {saveLoading ? (
          <>
            <Spinner animation='border' size='sm' className='me-2' />
            Kaydediliyor...
          </>
        ) : (
          'Kaydet'
        )}
      </Button>
    </form>
  )
}

export {EdmSettingsForm}
